import React from 'react';

function HeroSection() {
  return (
    <section className="hero">
      <div className="hero-logo">
        <img src="logo_mimadre.png" alt="Mimadre" className="main-logo" />
      </div>
      <div className="hero-image">
        <img src="biografia.png" alt="Inmaculada Fuentes" className="author-photo" />
      </div>
      <div className="hero-content">
        <h3>Me presento</h3>
        <h1>Mimadre Universe</h1>
        <h2>Edición de libros infantiles</h2>
        <p>No publicamos libros, publicamos universos</p>
      </div>
    </section>
  );
}

export default HeroSection;